import React, { useState, useEffect } from 'react';
import "./about.css";
import aboutimage from "../../assets/cc61d568fdbc87905f69a067c58290a19213d5aa.png";
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';

function About() {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  return (
    <>
      <div className='container-fluid about-container'>
        <section>
          <center>
            <div className='heading-for-all' data-aos="fade-up">
              <h2>About Electiaa</h2>
            </div>
          </center>
        </section>

        <div className='row'>
          {/* Image Column */}
          <div className='col-md-6 image-col' data-aos="fade-right" data-aos-delay="2000">
            <img src={aboutimage} alt="About Us" className="about-img" />
          </div>

          {/* Content Column */}
          <div className='col-md-6 content-col' data-aos="fade-left" data-aos-delay="2000">
            <div className='about-text'>
              <div className='about-para'>
                <p>
                  At <span className='text-change'>Electiaa</span>, we blend creativity, technology, and strategy to deliver digital solutions that drive real results. As a full-service agency, we specialize in website design, web development, and digital marketing, helping businesses build a strong online presence and grow in the digital era.
                </p>
                <p>
                  From eye-catching websites to fully functional web platforms, our design and development team brings your vision to life with precision and innovation. We build digital experiences that are fast, responsive, and user-centric.
                </p>
                <p>
                  Our digital marketing experts craft tailored campaigns across SEO, social media, Google Ads, and more — ensuring your brand reaches the right audience at the right time.
                </p>
              </div>
            </div>

            <div className="container d-flex justify-content-center my-4">
              <button className="button-all" onClick={handleShow}>
                Get Enquiry
              </button>
            </div>
          </div>
        </div>
      </div>

      <Formpage show={show} onClose={handleClose} />
    </>
  );
}

export default About;
